// extracted by mini-css-extract-plugin
export var deliveryRow = "_t7-a";
export var fixedHeight = "_t7-4";
export var freightLogo = "_t7-9";
export var fullWidth = "_t7-3";
export var priceColumn = "_t7-5";
export var radioSelected = "_t7-7";
export var radioUnselected = "_t7-6";
export var selectedOption = "_t7-2";
export var selectedOptionContainer = "_t7-1";
export var selection = "_t7-0";
export var tallSkeletonText = "_t7-8";